import React, { forwardRef } from 'react';
import { TableCell, TableSortLabel, Tooltip, SxProps } from '@mui/material';
import { classes } from './styles';
import { TSortableColumn, TPaginationState } from './types';

interface ITooltipTableCellProps {
  header: TSortableColumn;
  paginationState: TPaginationState<string>;
  onSortChange: (id: string) => void;
  sx: SxProps;
}

const TooltipTableCell = forwardRef<HTMLTableCellElement, ITooltipTableCellProps>(
  ({ header, paginationState, onSortChange, sx }, ref) => {
    if (!header.enabled) {
      return null;
    }
    const sortActive = paginationState.sort === header.id;
    const sortDirection = sortActive ? paginationState.sort_order || 'asc' : 'asc';

    const tableCell = (
      <TableCell ref={ref} sx={sx}>
        <TableSortLabel
          active={sortActive}
          direction={sortDirection}
          onClick={() => onSortChange(header.id)}
          sx={header.sortable ? classes.sortable : classes.notSortable}
          disabled={!header.sortable}
          id={`${header.id}-sort-label`}
        >
          {header.label}
        </TableSortLabel>
      </TableCell>
    );

    if (header.tooltip) {
      return (
        <Tooltip key={header.id} title={header.tooltip} arrow>
          {tableCell}
        </Tooltip>
      );
    }

    return tableCell;
  }
);

TooltipTableCell.displayName = 'TooltipTableCell';

export default TooltipTableCell;
